import { useGetNotificationsQuery } from '@/features/slice/notification';
import { useUrlFilter, useUrlPagination } from '@/hooks';

const NOTIFICATION_STATUS_FILTER_KEY = 'status';

export const useNotificationList = () => {
    const { page, limit } = useUrlPagination();
    const { getSearchFilter } = useUrlFilter();

    const status = getSearchFilter(NOTIFICATION_STATUS_FILTER_KEY);

    const queryParams = {
        page,
        limit,
        sort_by: 'created_at',
        sort_order: 'desc',
    };

    if (status) {
        Object.assign(queryParams, { status });
    }

    const { data, isLoading, isError, error, isFetching } =
        useGetNotificationsQuery(queryParams);

    return { data, isLoading, isError, error, isFetching };
};
